import {SearchIcon} from '@primer/octicons-react'
import type {SxProp} from '@primer/react'
import {Autocomplete, FormControl} from '@primer/react'
import {useState} from 'react'

type AutocompleteItem = {text: string; id: string}

export type AutocompleteProps = {
  items: Array<AutocompleteItem>
  label?: string
  hideLabel?: boolean
  onSelect: (item: AutocompleteItem) => void
  selectedItem?: AutocompleteItem
  required?: boolean
} & SxProp

export function AutocompleteSearch({
  items,
  label = 'Search',
  onSelect,
  hideLabel = true,
  selectedItem = {text: '', id: '0'},
  required = false,
  sx,
}: AutocompleteProps) {
  const onSelectedChange = (selected: AutocompleteItem | Array<AutocompleteItem>) => {
    if (!Array.isArray(selected)) {
      return
    }

    const newlySelectedArray = selected.filter(function (item) {
      if (item?.id) {
        return selectedItem.id !== item.id
      }
    })
    const newlySelected = newlySelectedArray[0] ? newlySelectedArray[0] : {text: '', id: '0'}

    onSelect(newlySelected)
  }

  const [filterValue, setFilterValue] = useState('')
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterValue(event.target.value)
  }

  const fuzzySearchFilter = (item: AutocompleteItem) => {
    return item.text.toLowerCase().includes(filterValue.toLowerCase())
  }

  return (
    <FormControl sx={{paddingX: '6px', paddingY: '8px', marginX: '8px', ...sx}} required={required}>
      <FormControl.Label visuallyHidden={hideLabel} id="autocompleteSearch">
        {label}
      </FormControl.Label>
      <Autocomplete>
        <Autocomplete.Input
          placeholder={label}
          value={selectedItem.text}
          onChange={handleInputChange}
          leadingVisual={SearchIcon}
          sx={{width: '100%'}}
          name="autocomplete-input"
        />
        <Autocomplete.Overlay sx={{overflow: 'auto', maxHeight: '200px'}}>
          <Autocomplete.Menu
            items={items}
            selectedItemIds={[selectedItem.id]}
            aria-labelledby="autocompleteSearch"
            onSelectedChange={onSelectedChange}
            filterFn={fuzzySearchFilter}
          />
        </Autocomplete.Overlay>
      </Autocomplete>
    </FormControl>
  )
}

try{ AutocompleteSearch.displayName ||= 'AutocompleteSearch' } catch {}